import ForagePinElement from './ForagePinElement';

export default ForagePinElement;
